import { z } from "zod/v4";
import { PHONE_REGEX } from "../constants.js";
import { SOURCE_VALUES } from "../../subscription-contract/index.js";
import { OptionalEmailSchema } from "../../customer/schemas/email-schema.js";
import { OptionalBirthDateSchema } from "../../customer/schemas/birth-date-schema.js";
export const CommonContractFields = z.object({
    phone_number: z
        .string()
        .min(1, "Telefonnummer må fylles ut. ")
        .regex(PHONE_REGEX, "Ugyldig telefonnummer. ")
        .optional(),
    first_name: z
        .string({
        error: (issue) => issue.input === undefined ? "Påkrevd felt. " : undefined,
    })
        .min(1, "Fornavn må fylles ut. "),
    last_name: z
        .string({
        error: (issue) => issue.input === undefined ? "Påkrevd felt. " : undefined,
    })
        .min(1, "Etternavn må fylles ut. "),
    birth_date: OptionalBirthDateSchema,
    email: OptionalEmailSchema,
    delivery_first_name: z
        .string({
        error: (issue) => issue.input === undefined ? "Påkrevd felt. " : undefined,
    })
        .min(1, "Leveringsfornavn må fylles ut. "),
    delivery_last_name: z
        .string({
        error: (issue) => issue.input === undefined ? "Påkrevd felt. " : undefined,
    })
        .min(1, "Leveringsetternavn må fylles ut. "),
    delivery_address: z
        .string({
        error: (issue) => issue.input === undefined ? "Påkrevd felt. " : undefined,
    })
        .min(1, "Leveringsadresse må fylles ut. "),
    delivery_zip_code: z
        .string({
        error: (issue) => issue.input === undefined ? "Påkrevd felt. " : undefined,
    })
        .length(4, {
        error: "Postnummer må være 4 siffer. ",
    }),
    delivery_city: z
        .string({
        error: (issue) => issue.input === undefined ? "Påkrevd felt. " : undefined,
    })
        .min(1, "Leveringssted må fylles ut. "),
    billing_first_name: z
        .string({
        error: (issue) => issue.input === undefined ? "Påkrevd felt. " : undefined,
    })
        .min(1, "Fakturafornavn må fylles ut. "),
    billing_last_name: z
        .string({
        error: (issue) => issue.input === undefined ? "Påkrevd felt. " : undefined,
    })
        .min(1, "Fakturaetternavn må fylles ut. "),
    billing_address: z
        .string({
        error: (issue) => issue.input === undefined ? "Påkrevd felt. " : undefined,
    })
        .min(1, "Fakturaadresse må fylles ut. "),
    billing_zip_code: z
        .string({
        error: (issue) => issue.input === undefined ? "Påkrevd felt. " : undefined,
    })
        .length(4, {
        error: "Postnummer må være 4 siffer. ",
    }),
    billing_city: z
        .string({
        error: (issue) => issue.input === undefined ? "Påkrevd felt. " : undefined,
    })
        .min(1, "Fakturasted må fylles ut. "),
    sku: z
        .string({
        error: (issue) => issue.input === undefined ? "Påkrevd felt. " : undefined,
    })
        .min(1, "SKU må fylles ut. "),
    next_isbn: z
        .string({
        error: (issue) => issue.input === undefined ? "Påkrevd felt. " : undefined,
    })
        .trim()
        .min(1, "ISBN må fylles ut. ")
        .refine((val) => val.toLowerCase() !== "null", {
        error: "Kan ikke være 'NULL'. ",
    })
        .refine((val) => !/[eE]\+?\d+/.test(val), {
        error: "Ugyldig ISBN-format. ",
    })
        .refine((val) => /^\d{13}$/.test(val), {
        error: "ISBN må være 13 siffer. ",
    }),
    salto_customer_florida_id: z
        .string()
        .regex(/^\d+$/, "Florida-ID må kun inneholde tall. ")
        .optional(),
    salto_debt_status: z
        .string()
        .optional()
        .refine((status) => status === undefined || status === "ACTIVE", {
        message: "Inkasso-status må være ACTIVE hvis satt.",
    }),
    dds_id: z.string().optional(),
    data_factory_id: z.string().optional(),
    kindle_email: OptionalEmailSchema,
    verified_email: OptionalEmailSchema,
    pause_start: z.string().optional(),
    pause_stop: z.string().optional(),
    company: z.string().optional(),
});
const SaltoContractSchema = CommonContractFields.extend({
    source: z.literal(SOURCE_VALUES.SALTO),
    salto_customer_id: z
        .string({
        error: (i) => (i.input === undefined ? "Påkrevd felt. " : undefined),
    })
        .min(1, "Salto kunde-ID må fylles ut. "),
    salto_subscription_id: z
        .string({
        error: (issue) => issue.input === undefined ? "Påkrevd felt. " : undefined,
    })
        .min(1, "Salto abonnement-ID må fylles ut. "),
    salto_created_at: z
        .string({
        error: (issue) => issue.input === undefined ? "Påkrevd felt. " : undefined,
    })
        .min(1, "Salto innmeldingsdato må fylles ut. "),
    renew_at: z
        .string({
        error: (issue) => issue.input === undefined ? "Påkrevd felt. " : undefined,
    })
        .min(1, "Kjøredato må fylles ut. "),
    interval: z.number({
        error: (issue) => issue.input === undefined
            ? "Intervall må fylles ut, må være 1, 2, 4 eller 6. "
            : undefined,
    }),
});
const TMContractSchema = CommonContractFields.extend({
    source: z.literal(SOURCE_VALUES.TM),
    phone_number: z
        .string()
        .min(1, "Telefonnummer må fylles ut. ")
        .regex(PHONE_REGEX, "Ugyldig telefonnummer. ")
        .optional(),
    salto_customer_id: z.string().optional(),
    salto_subscription_id: z.string().optional(),
    salto_created_at: z.string().optional(),
    renew_at: z.string().optional(),
    interval: z.number().optional(),
});
export const ImportedContractSchema = z.discriminatedUnion("source", [
    SaltoContractSchema,
    TMContractSchema,
]);
